import React, { useContext } from 'react';
import { Button, Icon } from '@sumtotal/react-foundation';
import { useTranslation } from 'react-i18next';
import Config from '../../../config/Config';
import CurrentThemeContext from '../../../contexts/ThemeContext';
import { MobileAppHeader, MobileAppPageContainer } from './mobileAppMenuHeaderStyles';
import { Img } from '../../../modules/dashboards/components/templates/templateStyles';
import { ApplicationPaths } from '../../../authentication/AuthorizationConstants';
import useCustomNavigation from '../../hooks/useCustomNavigation';

const MobileAppMenu = () => {
  const navigate = useCustomNavigation();
  const themeContext = useContext(CurrentThemeContext);
  const { t } = useTranslation(['TRANSLATIONS_RCORE_ACTIVITY_QR_CODE_ATTENDANCE']);
  const { logoData } = themeContext;
  const [previewLogoUrl] = logoData;

  let LogoSrc = `${Config.domain}//${Config.logo}`;
  if (previewLogoUrl && previewLogoUrl !== '') {
    LogoSrc = previewLogoUrl;
  }
  const handleLogOut = () => {
    navigate(ApplicationPaths.Logout);
  };

  return (
    <>
      <MobileAppPageContainer>
        <MobileAppHeader>
          {/* If required we will add new Mobile App header component on react-foundation as part of UI changes for that we had separate story */}
          {LogoSrc !== '' && <Img className="logo-image" src={LogoSrc} />}
          <Button
            variant="text"
            size="small"
            onClick={handleLogOut}
            startIcon={<Icon iconType="MaterialIcon" iconName="ExitToApp" size={1} />}
          >
            {t('RCORE_QR_CODE_ATTENDANCE_LOGOUT')}
          </Button>
        </MobileAppHeader>
      </MobileAppPageContainer>
    </>
  );
};

export default MobileAppMenu;
